// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZbpCr"};